// Sygnał "po drugiej stronie jest człowiek" dla licznika odwiedzin (patrz HumanSignalView w
// api/visits.py i DailyVisitCount.human_count w models.py). Wysyłany raz na odsłonę, przy
// PIERWSZEJ realnej interakcji na widocznej karcie - boty zwykle w ogóle nie wykonują JS, a
// przeglądarki sterowane skryptem nie ruszają myszą ani nie przewijają. Celowo NIC nie zapisuje w
// przeglądarce (bez ciasteczek/localStorage) - serwer sam odróżnia "już potwierdzony dziś".
const HUMAN_EVENTS = ["pointermove", "pointerdown", "touchstart", "keydown", "wheel", "scroll"] as const;

let humanSignalSent = false;

function sendHumanSignal(event: Event): void {
    if (humanSignalSent || document.visibilityState !== "visible") return;
    // Zdarzenia wygenerowane skryptem strony (dispatchEvent) mają isTrusted=false.
    if (!event.isTrusted) return;
    humanSignalSent = true;
    HUMAN_EVENTS.forEach((name) => window.removeEventListener(name, sendHumanSignal));
    const csrfToken = document.cookie.match(/csrftoken=([^;]+)/)?.[1] ?? "";
    fetch("/api/visits/human/", {
        method: "POST",
        headers: { "Content-Type": "application/json", "X-CSRFToken": csrfToken },
        body: "{}",
        keepalive: true,
    }).catch(() => { /* licznik jest tylko poglądowy - błąd sieci nie ma wpływu na UX */ });
}

HUMAN_EVENTS.forEach((name) => window.addEventListener(name, sendHumanSignal, { passive: true }));
